export default "__VITE_ASSET__2f70a812__"